import Link from 'next/link';
import { isEqual } from 'lodash';

import { TabItem } from '../../../types/tabs';

/* eslint-disable-next-line */
type DynamicBreadcrumbsProps = {
  breadcrumbItems: TabItem[];
  hoverColor: string;
  position: string;
};

export function DynamicBreadcrumbs(props: DynamicBreadcrumbsProps) {
  const { breadcrumbItems, hoverColor, position } = props;

  const mapBreadcrumbItems = breadcrumbItems.map((breadcrumbItem, i) => {
    const isLastItem = isEqual(i, breadcrumbItems.length - 1);

    return (
      <Link key={breadcrumbItem.tabLabel} href={breadcrumbItem.route}>
        <a
          className={`${hoverColor} ${
            isLastItem ? "after:content-['']" : "after:content-['/']"
          } uppercase  after:px-1 text-primaryGray`}
        >
          {breadcrumbItem.tabLabel}
        </a>
      </Link>
    );
  });

  return (
    <div
      className={`text-subtitle font-BebasNeue space-x-1 sm:flex tracking-wide ${position}`}
    >
      {mapBreadcrumbItems}
    </div>
  );
}

export default DynamicBreadcrumbs;
